import { render } from "./TableHeading.vue?vue&type=template&id=7275debc"
import script from "./TableHeading.vue?vue&type=script&lang=js"
export * from "./TableHeading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__